module.exports = __webpack_public_path__ + "img/m2.ff9a43e5.png";